import { render, staticRenderFns } from "./WebSourceEditForm.vue?vue&type=template&id=5a1e9c4a&scoped=true&"
import script from "./WebSourceEditForm.vue?vue&type=script&lang=js&"
export * from "./WebSourceEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e9c4a",
  null
  
)

/* custom blocks */
import block0 from "./WebSourceEditForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a1e9c4a')) {
      api.createRecord('5a1e9c4a', component.options)
    } else {
      api.reload('5a1e9c4a', component.options)
    }
    module.hot.accept("./WebSourceEditForm.vue?vue&type=template&id=5a1e9c4a&scoped=true&", function () {
      api.rerender('5a1e9c4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/web-source-management/WebSourceEditForm.vue"
export default component.exports